<!-- @format -->
<style></style>

<template>
  <div id="report">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'report'
};
</script>
